/**
 * SECURITY FIX: Use environment variables for API URLs.
 * This file re-exports the same URL as config.tsx for backward compatibility.
 * Consider consolidating to a single config file.
 */
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.eleave.in/';
